module.exports = __webpack_public_path__ + "img/588x310-03.5ac0f363.png";